import { createSelector } from 'reselect'
import { AppGlobalState, Progress } from '../../types'
import { Household } from './types'
import { EntityMetadata } from 'modules/domain/types'

const dict = (state: AppGlobalState) => state.household.items
const ids = (state: AppGlobalState) => state.household.ids
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const item = (state: AppGlobalState, id: string): Household | undefined => state.household.items[id]
const meta = (state: AppGlobalState, id: string): EntityMetadata<Household> =>
  state.household.meta[id] || {
    fetchError: null,
    fetchProgress: Progress.IDLE,
    id,
    removeError: null,
    removeProgress: Progress.IDLE,
    updateError: null,
    updateProgress: Progress.IDLE,
  }
const itemFetchProgress = (state: AppGlobalState) => state.household.itemFetchProgress
const listFetchProgress = (state: AppGlobalState) => state.household.listFetchProgress
const listFetchError = (state: AppGlobalState) => state.household.listFetchError
const listFetchErrorDetail = (state: AppGlobalState) => state.household.listFetchErrorDetail
const listFetchNextProgress = (state: AppGlobalState) => state.household.listFetchNextProgress
const listFetchNextError = (state: AppGlobalState) => state.household.listFetchNextError
const listFetchNextErrorDetail = (state: AppGlobalState) => state.household.listFetchNextErrorDetail
const list = createSelector(dict, ids, listFetchProgress, (dict, ids, progress) => {
  if (progress === Progress.WORK) {
    return []
  }
  const result: Household[] = []
  for (const id of ids) {
    result.push(dict[id])
  }
  return result
})

const filter = (state: AppGlobalState) => state.household.filter
const sorting = (state: AppGlobalState) => state.household.sorting
const page = (state: AppGlobalState) => state.household.page
const total = (state: AppGlobalState) => state.household.total
const updateProgress = (state: AppGlobalState) => state.household.updateProgress
const removeProgress = (state: AppGlobalState) => state.household.removeProgress
const addProgress = (state: AppGlobalState) => state.household.addProgress
const hasNext = (state: AppGlobalState) => state.household.total > state.household.ids.length
const pageSize = (state: AppGlobalState) => state.household.pageSize
const pages = (state: AppGlobalState) => Math.ceil(state.household.total / state.household.pageSize)

const HouseholdSelectors = {
  filter,
  sorting,
  page,
  total,
  updateProgress,
  removeProgress,
  addProgress,
  item,
  meta,
  itemFetchProgress,
  listFetchProgress,
  listFetchError,
  listFetchErrorDetail,
  list,
  dict,
  ids,
  hasNext,
  pageSize,
  listFetchNextProgress,
  listFetchNextError,
  listFetchNextErrorDetail,
  pages,
}

export default HouseholdSelectors
